import React from 'react';
import {
  useLocation,
} from 'react-router-dom';
import {
  useApiClient, useFetch,
} from '@marageti/z4-lib';
import { Container } from '@mui/material';
import { TripHistories } from '@marageti/z4-sdk/lib/travel';
import ArchivedTripsView from './archived-trips-view';
import { useAuthStore } from '../../store';
import { BackNavigationView } from '../../components/back-navigation';
import { getHomeBackNavConfig } from '../../components/back-navigation/back-navigation-configs';
import { useBackNavigation } from '../../hooks/use-back-navigation';

const ArchivedTripsContainer = () => {
  const { loggedInTraveler } = useAuthStore();
  const apiClient = useApiClient();
  const travelerId = loggedInTraveler?.id;
  const location = useLocation();
  const routeArchivedTrips = location.state?.archivedTrips;
  const { primaryText, handleBack } = useBackNavigation(getHomeBackNavConfig);

  const {
    data: tripsData,
    isLoading,
    error,
  } = useFetch<TripHistories>(
    apiClient.peopleClient.getTravelerTripHistories,
    [travelerId],
    !!travelerId && !routeArchivedTrips,
  );

  const archivedTrips = routeArchivedTrips || tripsData?.archivedTrips || [];

  return (
    <>
      <BackNavigationView primaryText={primaryText} handleBack={handleBack} dataE2e="ztest-archived-trips-back-home" />
      <Container
        maxWidth="md"
        sx={{ pt: 3.75, pb: 8 }}
      >
        <ArchivedTripsView
          trips={archivedTrips}
          loading={isLoading && !routeArchivedTrips}
          error={error}
        />
      </Container>
    </>
  );
};

export default ArchivedTripsContainer;
